import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "!text-sm !leading-5 text-foreground min-w-[180px]" }
const _hoisted_2 = { class: "!text-sm !leading-5 text-muted-foreground" }
const _hoisted_3 = { class: "!text-sm !leading-5 text-muted-foreground" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'approved-request-card rounded-xl border bg-card text-card-foreground shadow flex flex-wrap items-center gap-x-6 gap-y-1 px-6 py-4',
      _ctx.data.state === 'UPDATED' ? 'cursor-pointer' : '',
    ]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToReviewSentRequest && _ctx.goToReviewSentRequest(...args)))
  }, [
    _createElementVNode("p", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "font-medium" }, "Partner Name:", -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.data.name), 1)
    ]),
    _createElementVNode("p", _hoisted_2, " Request Sent: " + _toDisplayString(_ctx.formatDate(_ctx.data.created_at)), 1),
    _createElementVNode("p", _hoisted_3, " Completed on: " + _toDisplayString(_ctx.data.response_at ? _ctx.formatDate(_ctx.data.response_at) : '-'), 1),
    _createElementVNode("span", {
      class: _normalizeClass([
        'ml-auto inline-flex items-center rounded-full px-2.5 py-0.5 !text-xs !font-medium',
        _ctx.data.state === 'COMPLETED'
          ? 'bg-green-100 text-green-800'
          : 'bg-orange-100 text-orange-800',
      ])
    }, _toDisplayString(_ctx.data.state), 3)
  ], 2))
}